"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructDefaultsMapFromRangeDefinition = exports.verify = exports.AttributeValidationError = void 0;
exports.isNumberMapAttributeKeyDefinitionOfType = isNumberMapAttributeKeyDefinitionOfType;
exports.isValidAttributeKeyDefinitionOfType = isValidAttributeKeyDefinitionOfType;
const common_1 = require("../common");
var AttributeValidationError;
(function (AttributeValidationError) {
    AttributeValidationError["OUTSIDE_RANGE"] = "OUTSIDE_RANGE";
    AttributeValidationError["NOT_NUMBER"] = "NOT_NUMBER";
    AttributeValidationError["INVALID_MEMBERS"] = "INVALID_MEMBERS";
    AttributeValidationError["NOT_PRESENT"] = "NOT_PRESENT";
    AttributeValidationError["NOT_BOOLEAN"] = "NOT_BOOLEAN";
    AttributeValidationError["NOT_ARRAY"] = "NOT_ARRAY";
    AttributeValidationError["NOT_ENUM_VALUE"] = "NOT_ENUM_VALUE";
    AttributeValidationError["NOT_BITMAP_VALUE"] = "NOT_BITMAP_VALUE";
})(AttributeValidationError || (exports.AttributeValidationError = AttributeValidationError = {}));
/** `0x5a` — 90 */
exports.verify = 0x5a;
const attx = {
    attributeType: 'enumeration',
    enumeration: common_1.AppValueTypes,
};
function isNumberMapAttributeKeyDefinitionOfType(x) {
    return typeof x === 'object' && x !== null && Object.values(x).every((v) => isValidAttributeKeyDefinitionOfType(v, 'number'));
}
function isValidAttributeKeyDefinitionOfType(x, attributeType) {
    return typeof x === 'object' && x !== null && x.attributeType === attributeType;
}
const constructDefaultsMapFromRangeDefinition = (rangeDef, level = 0) => {
    const defaultsMap = {};
    const supportedKeysNumerical = [];
    const supportedKeysMap = [];
    if (typeof rangeDef === 'object' && rangeDef !== null) {
        for (const key in rangeDef) {
            const def = rangeDef[key];
            if (def) {
                if ('attributeType' in def) {
                    if (def.attributeType === 'number') {
                        defaultsMap[key] = def.range.min;
                        if (level === 0) {
                            supportedKeysNumerical.push(key);
                        }
                    }
                    else if (def.attributeType === 'boolean') {
                        defaultsMap[key] = false;
                    }
                    else if (def.attributeType === 'enumeration') {
                        const enumValues = Object.values(def.enumeration);
                        defaultsMap[key] = enumValues[0];
                    }
                    else if (def.attributeType === 'array') {
                        defaultsMap[key] = [];
                    }
                    else if (def.attributeType === 'present') {
                        defaultsMap[key] = null;
                    }
                    else if (def.attributeType === 'bitmap') {
                        const { bitmap } = def;
                        defaultsMap[key] = bitmap;
                    }
                    else {
                        console.warn(`TEMP: constructDefaultsMapFromRangeDefinition level ${level} Unsupported attributeType: ${def.attributeType} for key ${key}`);
                    }
                }
                else {
                    defaultsMap[key] = (0, exports.constructDefaultsMapFromRangeDefinition)(def, level + 1).defaultsMap;
                    // console.log(`TEMP: constructDefaultsMapFromRangeDefinition level ${level} No AttributeType: key ${key} defaultsMap`, defaultsMap[key])
                    if (level === 0) {
                        supportedKeysMap.push(key);
                    }
                }
            }
            else {
                console.info(`WARN: constructDefaultsMapFromRangeDefinition level ${level} Invalid definition for key ${key}:`, def);
            }
        }
    }
    else {
        console.info(`WARN: constructDefaultsMapFromRangeDefinition level ${level} Invalid rangeDef:`, rangeDef);
    }
    return { defaultsMap, supportedKeysNumerical, supportedKeysMap };
};
exports.constructDefaultsMapFromRangeDefinition = constructDefaultsMapFromRangeDefinition;
